<template>
  <div class="flex-page">
    <a-row :gutter="30" type="flex" justify="center" v-if="isShowContent">
      <!--      :showUploadList="false"-->
      <a-col :span="14">
        <a-upload-dragger
          name="file"
          :multiple="false"
          :action="uploadUrl"
          :showUploadList="false"
          :before-upload="handleBeforeUploadExcelFile"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon" style="margin-bottom:20px;">
            <a-icon type="inbox" style="font-size: 78px;"/>
          </p>
          <p class="ant-upload-text" style="margin-bottom:20px;">点击或将文件拖拽到这里上传</p>
          <p class="ant-upload-hint">支持扩展名：.csv .xlsx .xls</p>
        </a-upload-dragger>
      </a-col>
      <a-col :span="6">
        <div class="text-download" @click="downloadFile">
          <span class="mr10">点击下载</span>
          <a>批量导入模板</a>
        </div>
        <div class="text-download">共识别到 {{ contactsNum }} 个联系人</div>
        <div class="text-download">
          <a-button type="primary" :loading="submitLoading" :disabled="staffContactParamId==0" @click="confirmImport">
            确认导入
          </a-button>
          <a-button @click="resetData">重 置</a-button>
        </div>
      </a-col>
    </a-row>
    <a-row v-else>
      <Error500></Error500>
    </a-row>
  </div>
</template>

<script>
import Error500 from '../../exception/500'

export default {
  name: 'ImportContacts',
  components: {
    Error500
  },
  data() {
    return {
      validateKey: this.$route.query.validateKey ? this.$route.query.validateKey : '',
      staffId: this.$route.query.staffId ? this.$route.query.staffId : '',
      uploadUrl: '',
      fileList: [],
      contactsNum: 0,
      staffContactParamId: 0,
      submitLoading: false,
      isShowContent: false
    }
  },
  mounted() {
    if (this.validateKey && this.validateKey) {
      this.checkValidate()
      this.uploadUrl = this.getAppConfig().apiUrl + 'staff/v2/consumerServer/initBatchStaffContact?staffId=' + this.staffId + '&validateKey=' + this.validateKey
    } else {
      this.isShowContent = false
    }
    document.querySelector('.container').setAttribute('style', 'background:none')
  },
  methods: {
    // 下载模板
    downloadFile() {
      window.open('https://imgb.woyoubooking.com/config/ImportContacts.xlsx')
    },
    resetData() {
      this.contactsNum = 0
      this.staffContactParamId = 0
    },
    // 图片上传
    handleChange(info) {
      const status = info.file.status
      this.getLogUtils().logWithTag('handleChange', info.fileList)
      if (status !== 'uploading') {
        this.getLogUtils().logWithTag(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.status == 1) {
          this.$message.success('文件上传成功')
          let data = info.file.response.data
          if (data) {
            this.contactsNum = data.count
            this.staffContactParamId = data.staffContactParamId
          }
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
      // let fileList = [...info.fileList];
      // fileList = fileList.slice(-1);
      // fileList = fileList.map(file => {
      //   if (file&&file.response&&file.response.status==1) {
      //     return file;
      //   }
      //   return "";
      // });
      // this.fileList = fileList;
      this.getLogUtils().logWithTag('handleChange', this.fileList)
    },
    //Excel文件校验
    handleBeforeUploadExcelFile(file) {
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = extensionsName === 'xls'
      const extension2 = extensionsName === 'xlsx'
      const extension3 = extensionsName === 'csv'
      if (!(extension || extension2 || extension3)) {
        this.$message.error('上传文件只能是csv、xls、xlsx格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    },
    //确认导入
    confirmImport() {
      let params = {
        staffContactParamId: this.staffContactParamId,
        staffId: this.staffId,
        validateKey: this.validateKey
      }
      this.submitLoading = true
      this.getHttpServices().getApiService().post('staff/v2/consumerServer/staffContactBatchAdd', params)
        .then(res => {
          this.$message.success('导入成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //验证
    checkValidate() {
      let url = 'staff/v2/consumerServer/checkStaffContactValidate?staffId=' + this.staffId + '&validateKey=' + this.validateKey
      this.getHttpServices().getApiService().post(url)
        .then(res => {
          if (res) {
            this.isShowContent = true
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
.flex-page {
  margin-top: 50px;
}

.mr10 {
  margin-right: 10px;
}

.text-download {
  margin-bottom: 15px;
}

.ant-btn + .ant-btn {
  margin-left: 15px;
}
</style>
